module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "withFooter": false
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-center"
  }, [_c('div', {
    staticClass: "l-col-10@md"
  }, [_c('div', {
    staticClass: "l-row infos"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v("\n            Dados do seu anúncio:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-center"
  }, [_c('div', {
    staticClass: "l-col-2@md img-product"
  }, [(_vm.announcementVariation.images[0].url) ? _c('img', {
    staticClass: "img-rounded",
    attrs: {
      "src": _vm.announcementVariation.images[0].url
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-10@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.announcementVariationName), function(attribute) {
    return _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v("\n                    " + _vm._s(attribute.value) + "\n                  ")])])
  }), 0)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "l-row infos"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v("\n            Dados do anúncio do marketplace:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-center"
  }, [_c('div', {
    staticClass: "l-col-2@md img-product"
  }, [(_vm.announcementToMatch.pictures[0].url) ? _c('img', {
    staticClass: "img-rounded",
    attrs: {
      "src": _vm.announcementToMatch.pictures[0].url
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-10@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('strong', {
    staticClass: "margin"
  }, [_vm._v("Título: ")]), _vm._v("\n                  " + _vm._s(_vm.announcementToMatch.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Código:")]), _vm._v(" "), (_vm.announcementToMatch.permalink) ? _c('a', {
    attrs: {
      "href": _vm.announcementToMatch.permalink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hint hint--bottom",
    attrs: {
      "data-label": "Clique para acessar no marketplace"
    }
  }, [_vm._v(" " + _vm._s(_vm.announcementToMatch.id) + " "), _c('i', {
    staticClass: "icon-new-tab"
  })])]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.productToMatchAttributes), function(attribute) {
    return _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v("\n                    " + _vm._s(attribute.value) + "\n                  ")])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-1@md btn-container"
  }, [_c('div', {
    staticClass: "l-row"
  }, [(_vm.match) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.redirectToNewAnnouncement
    }
  }, [_vm._v("Visualizar o novo anúncio\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-1@md btn-container"
  }, [_c('div', {
    staticClass: "l-row"
  }, [(_vm.elegible) ? _c('button', {
    staticClass: "btn btn--info",
    class: {
      'is-loading': _vm.isUpdating
    },
    attrs: {
      "disabled": _vm.match
    },
    on: {
      "click": _vm.updateAnnouncementToCheckout
    }
  }, [_vm._v("Match\n        ")]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12482409","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/match/Variation.vue
// module id = 2918
// module chunks = 0